"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calolziocorte": {
    "23ef6ed1": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "calolzio-casale": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4dd52abd": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "calolzio-centro": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12e36fe9": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "cornello": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b4155e09": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "erola": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "949b160a": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "foppenico": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ba2684b": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "gaggio": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0398e23": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "la-ca": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "edbc9437": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "lavello": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7db13f58": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "lorentino": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5072f288": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "monastero": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea18eaa2": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "oneta": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac3eb9b3": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "pascolo": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6ca676a4": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "rossino": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f62c0451": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ca5d932": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "skipSearch": false
    }],
    "sopracornola": [{
      "hkey": "61d9fb85",
      "slug": "calolziocorte",
      "name": "Calolziocorte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;